import React, { ReactElement, ReactNode } from 'react';
import { Tooltip } from 'react-tippy';

import {
  VerticalNavWrapper,
  NavItemInner,
  StyledVerticalNav,
  CollapseToggle,
} from './styles';

import { Separator } from 'ui/components';

import Icon from 'assets/icons';

type VerticalNavProps = {
  tabs: Array<tab>;
  activeTab: string;
  collapsed?: boolean;
  toggleCollapse?: () => void;
  onNavClick: (id: string) => void;
};

type tab = { label: string; id: string; icon?: ReactNode; groupEnd?: boolean };

function NavItem({
  tab,
  activeTab,
  onNavClick,
  collapsed,
}: {
  tab: tab;
  activeTab: string;
  collapsed?: boolean;
  onNavClick: (id: string) => void;
}) {
  return (
    <>
      <NavItemInner
        onClick={() => onNavClick(tab.id)}
        className={tab.id === activeTab ? 'active' : ''}
        collapsed={collapsed}
      >
        {tab.icon ? tab.icon : null}
        <span className="pr-v-nav-label">{tab.label}</span>
        <Icon.ChevronRight className="arrow-icon" ariaHidden={true} title="" />
      </NavItemInner>
      {tab.groupEnd ? (
        <Separator bg="grayDark" direction="x" mt={2} mb={2} />
      ) : null}
    </>
  );
}

function VerticalNav({
  tabs,
  onNavClick,
  activeTab,
  collapsed,
  toggleCollapse,
}: VerticalNavProps): ReactElement {
  return (
    <VerticalNavWrapper collapsed={collapsed}>
      <StyledVerticalNav>
        {tabs.map(tab => {
          return collapsed ? (
            <Tooltip
              animation="fade"
              title={tab.label}
              position="right-end"
              arrow={true}
            >
              <NavItem
                key={tab.label}
                tab={tab}
                activeTab={activeTab}
                onNavClick={onNavClick}
                collapsed={collapsed}
              />
            </Tooltip>
          ) : (
            <NavItem
              key={tab.label}
              tab={tab}
              activeTab={activeTab}
              onNavClick={onNavClick}
              collapsed={collapsed}
            />
          );
        })}
      </StyledVerticalNav>
      <Tooltip
        animation="fade"
        title={collapsed ? 'Expand' : 'Collapse'}
        position="right"
        arrow={true}
      >
        <CollapseToggle onClick={toggleCollapse}>
          {collapsed ? <Icon.ChevronRightDouble /> : <Icon.ChevronLeftDouble />}
        </CollapseToggle>
      </Tooltip>
    </VerticalNavWrapper>
  );
}

export { VerticalNav };
